export const isStaging = () => {
    return window.location.hostname.split('.').indexOf('staging') !== -1
}

export const isProduction = () => {
    return !isDevelopment() && !isStaging()
}

export const isDevelopment = () => {
    return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev'
}

export const isLocalDevelopment = () => {
    return isLocalHost() || isPrivateHost() || isYouVisitLocalHostDomain()
}

export const isLocalHost = () => {
    return Boolean(
        window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    )
}

export const isPrivateHost = () => {
    return Boolean(window.location.hostname.match(/^(10|172|192)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))
}

export const isYouVisitLocalHostDomain = () => {
    return window.location.hostname == 'local.dev.youvisit.com'
}

export const environmentSubdomain = () => {
    return window.location.hostname.split('.')[0]
}

export const isHTTPS = () => {
    return window.location.protocol.indexOf('s') !== -1
}

const LOCAL_STORE_PREFIX = 'yv_settings:'

const getLocalEnvironmentVariables = _ => {
    return Object.entries(localStorage)
        .filter(([key, _]) => key.startsWith(LOCAL_STORE_PREFIX))
        .reduce(
            (acc, [key, value]) => ({
                ...acc,
                [key.replace(LOCAL_STORE_PREFIX, '')]: value,
            }),
            {}
        )
}

const getProcessEnvironmentVariables = _ => process.env

export const getEnvironmentVariables = () => ({
    ...getProcessEnvironmentVariables(),
    ...getLocalEnvironmentVariables(),
})

export const getEnv = variableName => {
    if (process.env['NODE_ENV'] === 'production') return process.env[variableName]
    try {
        return localStorage.getItem(`${LOCAL_STORE_PREFIX}${variableName}`) || process.env[variableName]
    } catch (error) {}
    return process.env[variableName]
}

export const setEnv = (variableName, item) => localStorage.setItem(`${LOCAL_STORE_PREFIX}${variableName}`, item)
